<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="searchBar">
      <el-button
        size="small"
        v-hasPerm="btn_perm_type.menu.add"
        @click="handleEdit()"
        icon="el-icon-plus"
        >新增</el-button
      >
    </el-row>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
      row-key="id"
      :default-expand-all="false"
      :tree-props="defaultProps"
    >
      <el-table-column align="left" sortable prop="name" label="名称">
      </el-table-column>
      <el-table-column align="left" sortable prop="url" label="URL地址">
      </el-table-column>
      <el-table-column align="left" sortable prop="perms" label="权限标识">
      </el-table-column>
      <el-table-column align="center" sortable prop="orderNum" label="排序">
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="type"
        label="菜单类型"
        :formatter="handleFormatType"
      >
      </el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.menu.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.menu.delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑界面 -->
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :editForm="editForm"
      @confirm="handleEditForm"
    ></EditForm>
  </div>
</template>

<script>
import { listMenu, delMenu } from "@/api/system/menu";
import { listToTree, timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";
import EditForm from "./add-edit";

export default {
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      editFormVisible: false,
      loading: false,
      title: "添加菜单",
      userData: [],
      editForm: {
        name: "",
        perms: "",
        type: "",
        url: "",
      },
      defaultProps: {
        children: "children",
        hasChildren: "hasChildren",
      },
    };
  },
  components: {
    EditForm,
  },
  created() {
    this.getData();
  },
  methods: {
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    handleFormatType(row, column, cellValue) {
      return cellValue === 0 ? "目录" : cellValue === 1 ? "菜单" : "按钮";
    },
    getData() {
      this.loading = true;
      listMenu()
        .then((data) => {
          this.userData = listToTree(data);
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit(row) {
      if (row) {
        this.title = "修改菜单";
        row.type = row.type + "";
        this.editForm = row;
      } else {
        this.title = "添加菜单";
        this.editForm = {};
      }
      this.editFormVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delMenu(row.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.getData();
            })
            .catch(() => {
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleEditForm() {
      this.getData();
    },
  },
};
</script>

<style>
.searchBar {
  margin-top: 20px;
  height: 50px;
}
</style>




// WEBPACK FOOTER //
// src/views/system/menu/index.vue